import { Svg } from '@repo/ui';

import ErrorBaseView, { ErrorBaseViewController } from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';

interface Props {
  onPrimaryButtonClick: () => void;
}

const HometaxUnavailableTimeError = ({ onPrimaryButtonClick }: Props) => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <Svg src="icg_clock_md.svg" width={80} height={80} />,
    title: '아침 6시 이후에\n다시 조회해주세요',
    description: '매일 밤 0시부터 아침 6시까지\n홈택스 점검으로 환급액 조회가 어려워요.',
    primaryButtonText: '홈으로',
    onPrimaryButtonClick: onPrimaryButtonClick,
    primaryButtonVariant: 'tonal-secondary'
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export default HometaxUnavailableTimeError;
